import React from "react";
import './DemoContainer.scss'

import Play from "./components/play/Play";
import DemoContainerMenu from "./DemoContainerMenu";

import device01 from './assets/images/demo-devices/iPhone X-1.png';
import device02 from './assets/images/demo-devices/iPhone X-2.png';
import device03 from './assets/images/demo-devices/iPhone X-3.png';
import device04 from './assets/images/demo-devices/iPhone X-4.png';
import device05 from './assets/images/demo-devices/iPhone X-5.png';

interface DemoContainerProps {
    onStyleChange : (id:number)=>void;
    skin:number
}

export default class DemoContainer extends React.Component <DemoContainerProps>{

    state = {skinId:0 , mobileScale:true}
    skins = [device01 , device02,device03,device04,device05];

    playContainer = React.createRef<HTMLDivElement>();
    play = React.createRef<any>();

    componentDidMount = ()=>{
        this.setState({skinId:this.props.skin});
        this.onScaleChange(true);
    }

    onStyleChange = (id:number)=>{
        this.setState({skinId:id !== -1 ? id : 0})
        this.props.onStyleChange(id);
    }

    onScaleHandler = ()=>{

        this.onScaleChange(!this.state.mobileScale);
    }

    onScaleChange = (mobileScale : boolean)=>{

        this.setState({mobileScale:mobileScale})
;
        this.playContainer.current.style.width = mobileScale ? '488px' : '100%';
        this.playContainer.current.style.height = mobileScale? '892px' :  '100%';
        this.playContainer.current.style.transform = mobileScale ? 'scale(0.7)' : 'scale(1)';
        this.playContainer.current.style.marginLeft = mobileScale ? 'calc(50% - 190px)' : '0px';
        this.playContainer.current.style.marginTop = mobileScale ? '125px' : '0px';

        if(this.play && this.play.current)
            this.play.current.onResizeHandler();
    }

    render(){
        return (
            <div className="demo-container">
                <DemoContainerMenu onStyleChange={this.onStyleChange} onScaleHandler={this.onScaleHandler}/>
                <div ref={this.playContainer} className="play-container">
                    <Play ref={this.play}/>
                </div>
                <div className="container-background">
                    {this.getMobileBackground()}
                </div>
            </div>
        )
    }

    getMobileBackground = ()=>{

        if(this.state.mobileScale)
            return <img src={this.skins[this.state.skinId]} alt="" />;
        else
            return <div></div>;
    }

}